/**
* @version GENERATOR_VERSION::20200422
* @DateTime 2020-05-01T18:25:53.632
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';
import {
	listOrgPositionManage,
	listOrgPositionManageInit,
	listOrgPositionManageByAuthorizations,
	deleteOrgPositionManage
} from '@api/systemmanage/OrgPositionManage';

import {
	cloneObj
} from '@/plugins/utils'

import RespCommonDef from '@/plugins/utils/RespCommonDef'

export default {
	namespaced: true,
	state: {	
		// 初始化信息
		CompoundEntitiesDictionary: cloneObj(RespCommonDef.CompoundEntitiesDictionary),
		//查询接口返回的数据
		CompoundEntities: cloneObj(RespCommonDef.CompoundEntities),
	    Entities:cloneObj(RespCommonDef.Entities),
		//查询条件
		AdvanceQuery:cloneObj(RespCommonDef.AdvanceQuery),
	},

	actions: {
		listOrgPositionManage({
			state
		}) {
			return new Promise((resolve, reject) => {
				listOrgPositionManage(state.AdvanceQuery)
					.then(async res => {
						state.Entities = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listOrgPositionManageByAuthorizations({
			state
		}) {
			return new Promise((resolve, reject) => {
				listOrgPositionManageByAuthorizations(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntities =res
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listOrgPositionManageInit({
			state
		}) {
			return new Promise((resolve, reject) => {
				listOrgPositionManageInit(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntitiesDictionary = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		deleteOrgPositionManage({
			state
		}, {id}) {
			return new Promise((resolve, reject) => {
				deleteOrgPositionManage({
						id
					})
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

	}
};
